import React, { useEffect, useState } from 'react';
import './Contact.scss';
import ContactCard from './ContactCard';
import api from '../../api';
import ContainerLoader from '../loader/container-loader';

function Contact() {
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    const groupData = (baseData) => {
        const map = new Map();
        baseData.forEach(item => map.set(item.id, { ...item, subDepartments: [] }));
        
        const finalData = [];
        baseData.forEach(item => {
            if (item.parentid) {
                map.get(item.parentid)?.subDepartments.push(map.get(item.id));
            } else {
                finalData.push(map.get(item.id));
            }
        });
        
        return finalData;
    };

    const fetchDepartments = async () => {
        try {
            setIsFetching(true);
            const request = { resource: 'api/departments' };
            const response = await api.clientsinformation.getDetails(request);
            const filteredData = response?.data?.data?.res?.filter(item => (item.isdeleted === false));
            const groupedData = groupData(filteredData);
            setData(groupedData);
        } catch (error) {
            console.log(error.message);
        } finally {
            setIsFetching(false);
        }
    }

    useEffect(() => {
        fetchDepartments();
    }, []);

    return (<div className='contactContainer'>
        <h3 className='title my-4 ms-4'>Business Units</h3>
        {isFetching ? <ContainerLoader /> :
            <div className='d-flex flex-wrap justify-content-center mb-5 mx-auto'>
                {data?.map((contact) => (
                    <ContactCard key={contact.id} baseData={contact} />
                ))}
            </div>
        }
    </div>
    )
}

export default Contact;
